let bodyEl = null
let navIsVisible = false
let navWrapEl = null
let navBtn = null
let navOpenIcon = null
let navCloseIcon = null


// We need a .closest polyfill for IE9.
if (!Element.prototype.matches) {
  Element.prototype.matches = Element.prototype.msMatchesSelector || Element.prototype.webkitMatchesSelector
}

if (!Element.prototype.closest) {
  Element.prototype.closest = function (s) {
    var el = this
    do {
      if (el.matches(s)) return el
      el = el.parentElement || el.parentNode
    } while (el !== null && el.nodeType === 1)
    return null
  }
}

export function initialize() {
  bodyEl = document.querySelector('body')
  navBtn = document.querySelector('[data-db-nav-toggle]')
  navWrapEl = document.querySelector('[data-db-nav-wrap]')

  if (navWrapEl) {
    navOpenIcon = navBtn.querySelector('span:first-of-type')
    navCloseIcon = navBtn.querySelector('span:last-of-type')

    addListeners()
  }
}


export function addListeners() {
  document.addEventListener('keyup', handleKeyPresses, false)
  document.addEventListener('click', handleDocClick, false)
  navBtn.addEventListener('click', toggleNav, false)
}


// Handle keypresses, especially the escape key.
export function handleKeyPresses(event) {
  if (event.keyCode === 27) {
    if (navIsVisible) {
      toggleNav(event)
    }
  }
}


export function handleDocClick(event) {
  // If the user clicks anywhere except somewhere within .db-header…
  if (!event.target.closest('.db-header')) {
    // …and if the nav is already visible…
    if (navIsVisible) {
      // …toggle the nav.
      toggleNav(event)
    }
  }
}

// Toggle mobile (only) nav.
export function toggleNav(event) {
  navIsVisible = !navIsVisible
  bodyEl.classList.toggle('nav-open')
  navBtn.setAttribute('aria-expanded', navIsVisible)
  navWrapEl.hidden = !navIsVisible
  navOpenIcon.classList.toggle('hidden')
  navCloseIcon.classList.toggle('hidden')
  event.stopPropagation()
}
